import { CloseIcon } from '@synergy/theme-next';
import { IconButton, InputAdornment, StandardTextFieldProps, TextField, styled } from '@mui/material';
import { ReactElement } from 'react';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

interface CustomSearchBarProps extends StandardTextFieldProps {
    size?: 'small' | 'medium';
    backgroundColor?: 'transparent';
}

const SearchBar = styled(TextField)<CustomSearchBarProps>(({ theme, size, backgroundColor }) => ({
    minWidth: size === 'small' ? theme.spacing(26) : theme.spacing(42),
    width: '100%',

    '& .MuiOutlinedInput-root': {
        borderRadius: theme.spacing(2.5),
        height: theme.spacing(5),
        paddingRight: '0.2rem',
    },

    '& .MuiOutlinedInput-input': {
        paddingLeft: 0,
    },
}));

export interface FilterSearchBarProps extends Omit<StandardTextFieldProps, 'onChange' | 'size' | 'backgroundColor'> {
    size?: 'small' | 'medium';
    backgroundColor?: 'transparent';
    onChange?: (value: string) => void;
}

export const PoolFilterSearchBar = (props: FilterSearchBarProps): ReactElement => {
    const { onChange, size, backgroundColor, ...baseProps } = props;

    const inputProps = {
        startAdornment: (
            <InputAdornment position="start">
                <SearchRoundedIcon />
            </InputAdornment>
        ),
        endAdornment: props.value !== '' && (
            <InputAdornment position="end">
                <IconButton onClick={() => onChange?.('')}>
                    <CloseIcon />
                </IconButton>
            </InputAdornment>
        ),
    };

    return (
        <SearchBar
            autoFocus={true}
            {...baseProps}
            onChange={e => onChange?.(e.target.value)}
            InputProps={inputProps}
            size={size}
            backgroundColor={backgroundColor}
        />
    );
};
